import { useNavigate } from 'react-router-dom'
import { Trans, useTranslation } from '@clofo/i18n'
import { logo } from '@clofo/ui/images'
import { Button } from '@clofo/ui/button'
import { usePageTitle } from '@clofo/ui/hooks'

type RegistrationErrorProps = {
  titleKey: 'login.registration.expiredTitle' | 'login.registration.notFoundTitle'
  descriptionKey: 'login.registration.expiredDescription' | 'login.registration.notFoundDescription'
  pageTitleKey: 'login.registration.expiredTitle' | 'login.registration.notFoundPageTitle'
}

/**
 * Shared layout for the static registration error pages (expired / not-found invitation key).
 * The description strings embed a <contact> tag rendered as a mailto link to support.
 */
export const RegistrationError = ({
  titleKey,
  descriptionKey,
  pageTitleKey,
}: RegistrationErrorProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  usePageTitle(t(pageTitleKey))

  return (
    <main className='flex flex-col bg-background items-center justify-center'>
      <img src={logo} alt='Closing Folders' className='my-13 h-15' />
      <div className='w-full max-w-xl px-4'>
        <h1 className='text-xl font-semibold mb-6'>{t(titleKey)}</h1>
        <p className='leading-relaxed'>
          <Trans
            t={t}
            i18nKey={descriptionKey}
            components={{
              contact: (
                <a
                  className='text-primary font-medium hover:underline'
                  href='mailto:support@closingfolders.com'
                />
              ),
            }}
          />
        </p>
        <hr className='my-6 border-secondary' />
        <Button size='lg' className='w-fit' onClick={() => navigate('/')}>
          {t('login.registration.backToLogin')}
        </Button>
      </div>
    </main>
  )
}
